import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import ProblemsListView from "./ProblemsListView";
import Arrow from "./Arrow";

function TFloorsView() {
  const BACKEND_URL = process.env.REACT_APP_HOTHREAT_BACKEND_URL;
  const [floors, setFloors] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [evacuationArrows, setEvacuationArrows] = useState([]);
  const [problems, setProblems] = useState({});
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [error, setError] = useState(null);
  const { hotelId, apiKey } = useParams();
  const [imageDimensions, setImageDimensions] = useState({
    naturalWidth: null,
    naturalHeight: null,
    displayedWidth: null,
    displayedHeight: null,
  });
  const imgRef = useRef(null);

  // Przechowujemy współrzędne pinezki w stanie
  const [pinCoordinates, setPinCoordinates] = useState({ x: null, y: null });
  const [pinCoordinatesReal, setPinCoordinatesReal] = useState({ x: null, y: null });

  const fetchRoomsForFloor = async (hotelId, apiKey, floorId) => {
    try {
      const response = await fetch(`${BACKEND_URL}/hotels/${hotelId}/${apiKey}/floors/${floorId}/rooms`);

      if (!response.ok) {
        throw new Error(`Błąd HTTP! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Wystąpił błąd podczas pobierania pokoi:", error);
    }
  }

  // Funkcja do pobierania pięter
  useEffect(() => {
    fetch(`${BACKEND_URL}/hotels/${hotelId}/${apiKey}/floors`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const floorss = data;
        for (let i = 0; i < floorss.length; i++) {
          const floor = floorss[i]
          fetchRoomsForFloor(hotelId, apiKey, floor.id)
            .then((roomss) => {
              floor["rooms"] = roomss
              setFloors(floorss);
            })
        }
      })
      .catch((err) => setError(err.message));
  }, [apiKey, hotelId, BACKEND_URL]);

  // Funkcja do pobierania problemów dla pokoju
  const fetchProblems = async (roomId) => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/hotels/${hotelId}/${apiKey}/locations/${roomId}/problems`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setProblems((prevProblems) => ({
        ...prevProblems,
        [roomId]: data,
      }));
    } catch (error) {
      console.error(`Error fetching problems for room ${roomId}:`, error);
    }
  };

  const getRooms = () => {
    const result = [];
    for (let i = 0; i < floors.length; i++) {
      const rooms = floors[i].rooms;
      if (Array.isArray(rooms)) {
        result.push(...rooms);
      }
    }
      return result;
//    }
  }

  // Pobieranie problemów dla wszystkich pokoi co 5 sekund
  useEffect(() => {
    const intervalId = setInterval(() => {
      getRooms().forEach((room) => {
        fetchProblems(room.id);
      });
    }, 5000);

    return () => clearInterval(intervalId); // Czyszczenie interwału po odmontowaniu komponentu
  }, [floors, hotelId]);

  // Funkcja do ustawiania nowej pozycji pinezki
  const handleSetPin = (event) => {
    const image = event.target;
    const imageRect = image.getBoundingClientRect();
    const x = event.clientX - imageRect.left;
    const y = event.clientY - imageRect.top;

    const x_real = (x * imageDimensions.naturalWidth) / imageDimensions.displayedWidth
    const y_real = (y * imageDimensions.naturalHeight) / imageDimensions.displayedHeight

    setPinCoordinates({ x, y });
    setPinCoordinatesReal({ x: x_real, y: y_real })
  };

  const setRoomsForFloor = (idx) => {
    if (idx > -1) {
      setRooms(floors[idx].rooms)
    } else {
      setRooms([])
    }
  }

  const setEvacuationArrowsForFloor = (idx) => {
    if (idx > -1) {
      const ea = JSON.parse(floors[idx].evacuation_arrows_str)
      setEvacuationArrows(ea)
    } else {
      setEvacuationArrows([])
    }
  }

  const handleCurrent = (currentIdx) => {
    setRoomsForFloor(currentIdx);
    setCurrentIndex(currentIdx);
    setEvacuationArrowsForFloor(currentIdx);
  }

  // Funkcja do zmiany widoku na poprzedni obraz
  const handlePrevious = () => {
    const prevIdx = currentIndex > -1 ? currentIndex - 1 : floors.length - 1;
    handleCurrent(prevIdx);
  };

  // Funkcja do zmiany widoku na następny obraz
  const handleNext = () => {
    const nextIdx = currentIndex < floors.length - 1 ? currentIndex + 1 : -1;
    handleCurrent(nextIdx);
  };

  const showMenu = () => {
    handleCurrent(-1);
  }

  // Funkcja do pobierania wymiarów obrazu
  const updateImageDimensions = () => {
    if (imgRef.current) {
      const img = imgRef.current;
      setImageDimensions({
        naturalWidth: img.naturalWidth,
        naturalHeight: img.naturalHeight,
        displayedWidth: img.clientWidth,
        displayedHeight: img.clientHeight,
      });
    }
  };

  // Nasłuchiwanie zmiany rozmiaru okna i aktualizacja wymiarów obrazu
  useEffect(() => {
    const handleResize = () => {
      updateImageDimensions();
    };

    // Dodaj nasłuchiwanie na zmianę rozmiaru okna
    window.addEventListener('resize', handleResize);

    // Usuń nasłuchiwanie podczas unmount komponentu
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    updateImageDimensions(); // Zaktualizuj wymiary po zmianie obrazu
  }, [currentIndex]);

  // Funkcja do konwersji współrzędnych rzeczywistych na współrzędne wyświetlane
  const convertToDisplayedCoordinates = (xReal, yReal, log_info = "default") => {
    if (imageDimensions.naturalWidth && imageDimensions.displayedWidth) {
      const result = {
        x: ((xReal * imageDimensions.displayedWidth) / imageDimensions.naturalWidth) + 0,
        y: ((yReal * imageDimensions.displayedHeight) / imageDimensions.naturalHeight) + 0,
      };
      if (log_info !== "default") {
        console.log(log_info);
        console.log("result");
        console.log(result);
      }
      return result;
    }
    return { x: 0, y: 0 };
  };

  const calculateFontSize = () => {
    const baseFontSize = 24; // Bazowy rozmiar czcionki
    const minFontSize = 10
    if (imageDimensions.naturalWidth && imageDimensions.displayedWidth) {
      const result = (baseFontSize * imageDimensions.displayedWidth) / imageDimensions.naturalWidth;
      return result > minFontSize ? result : minFontSize;
    }
    return baseFontSize;
  };

  const [visibleRooms, setVisibleRooms] = useState({});

  const toggleRoomVisibility = (roomId) => {
    setVisibleRooms((prevState) => ({
      ...prevState,
      [roomId]: !prevState[roomId],
    }));
  };

  useEffect(() => {
    getRooms().forEach((room) => {
        fetchProblems(room.id);
      });
  }, [floors]);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px', position: 'relative' }}>
      <h1>Floors Viewer</h1>
      {error ? (
        <p style={{ color: "red" }}>Błąd: {error}</p>
      ) : floors.length > 0 ? (
        <div style={{ textAlign: 'center', marginTop: '20px', position: 'relative' }}>
          {currentIndex > -1 && (
            <>
              {/* Informacja o aktualnym obrazie */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ textAlign: 'left', cursor: "pointer", color: "#007bff", margin: '20px' }} onClick={showMenu}><strong>Menu</strong></div>
                <p style={{ flex: 1, textAlign: 'center' }}>
                  <strong>{floors[currentIndex].name}</strong>
                </p>
              </div>
              <p>
                Wyświetlono: {currentIndex + 1} z {floors.length}
              </p>

              {/* Informacja o wymiarach obrazu */}
              <div style={{ marginTop: "10px" }}>
                <p>
                  <strong>Wymiary rzeczywiste:</strong> {imageDimensions.naturalWidth}px x {imageDimensions.naturalHeight}px
                </p>
                <p>
                  <strong>Wymiary wyświetlane:</strong> {imageDimensions.displayedWidth}px x {imageDimensions.displayedHeight}px
                </p>
              </div>
            </>
          )}

          {currentIndex === -1 && (
              <p>
                <strong>Menu</strong>
              </p>
          )}

          {/* Przyciski nawigacji */}
          <div style={{ marginTop: "10px" }}>
            <button
              onClick={handlePrevious}
              style={{
                marginRight: "10px",
                padding: "10px 20px",
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Poprzedni
            </button>
            <button
              onClick={handleNext}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Następny
            </button>
          </div>

          {/* Wyświetlenie współrzędnych */}
          <div style={{ marginTop: '20px' }}>
            <p>
              {pinCoordinates.x !== null && pinCoordinates.y !== null
                ? `Pinezka ustawiona na: X: ${pinCoordinates.x.toFixed(0)}, Y: ${pinCoordinates.y.toFixed(0)}`
                : 'Kliknij na obraz, aby ustawić pinezkę.'}
            </p>
            <p>
              {pinCoordinatesReal.x !== null && pinCoordinatesReal.y !== null
                ? `Rzeczywiści na: X;Y: ;${pinCoordinatesReal.x.toFixed(0)},${pinCoordinatesReal.y.toFixed(0)}`
                : ''}
            </p>
          </div>

          {currentIndex === -1 && rooms.length === 0 && (
            <ProblemsListView
              floors={floors}
              problems={problems}
              currentIndex={currentIndex}
              setCurrentIndex={handleCurrent}
            />
          )}

          {currentIndex > -1 && rooms.length >= 0 && (
            <>
              {/* Wyświetlanie obrazu */}
              {/* Obraz z obsługą kliknięć */}
              <div style={{ display: 'inline-block', position: 'relative' }}>
                <img
                    ref={imgRef}
                    src={`${process.env.PUBLIC_URL}/images/plans/${floors[currentIndex].plan_file}`}
                    alt={floors[currentIndex].name}
                    onClick={handleSetPin} // Kliknięcie ustawia współrzędne pinezki
                    onLoad={updateImageDimensions} // Aktualizacja wymiarów po załadowaniu obrazu
                    style={{
                      maxWidth: '100%',
                      height: "auto",
                      border: "1px solid #ddd",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      marginBottom: "10px",
                    }}
                />

                {evacuationArrows.map((coordinates) => {
                  console.log("coordinates for line");
                  console.log(" " + coordinates[0][0] + ", " + coordinates[0][1]);
                  console.log(" " + coordinates[1][0] + ", " + coordinates[1][1]);
                  const start = convertToDisplayedCoordinates(coordinates[0][0], coordinates[0][1], "konwertujemy " + coordinates[0][0] + ", " + coordinates[0][1]);

                  const end = convertToDisplayedCoordinates(coordinates[1][0], coordinates[1][1], "konwertujemy " + coordinates[1][0] + ", " + coordinates[1][1]);
                  console.log("coordinates for line converted");
                  console.log(" " + start.x + ", " + start.y);
                  console.log(" " + end.x + ", " + end.y);
                  return (
                    <Arrow startX={start.x} startY={start.y} endX={end.x} endY={end.y} />
                  )

                })}

                {/* Zielone kółka na podstawie współrzędnych pokoi */}
                {rooms.map((room) => {
                  const { x, y } = convertToDisplayedCoordinates(room.x_coordinate, room.y_coordinate);
                  const fontSize = calculateFontSize();
                  const roomProblems = problems[room.id] || [];
                  const isProblemListVisible = visibleRooms[room.id] || false;

                  return (
                  <React.Fragment key={room.id}>
                    <div
                      style={{
                        position: 'absolute',
                        top: `${y}px`,
                        left: `${x}px`,
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                      }}
                    >
                      <div
                        onClick={() => toggleRoomVisibility(room.id)}
                        style={{
                          width: '12px',
                          height: '12px',
                          backgroundColor: roomProblems.length > 0 ? "red" : "green",
                          borderRadius: '50%',
                          boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                          marginBottom: '2px',
                          cursor: 'pointer',
                        }}
                      />
                    </div>

                    <div
                        style={{
                          position: 'absolute',
                          top: `${y + 2}px`,
                          left: `${x + 2}px`,
                          backgroundColor: roomProblems.length > 0 ? 'rgba(255,0,0,0.3)' : 'rgba(255, 255, 255, 0.9)',
                          border: '1px solid #ddd',
                          padding: '5px',
                          borderRadius: '4px',
                          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                          cursor: 'pointer',
                        }}
                        onClick={() => toggleRoomVisibility(room.id)}
                      >
                        <span
                          style={{
                            fontSize: `${fontSize}px`,
                            fontWeight: 'bold',
                          }}>
                          {room.name}
                          {roomProblems.length > 0 && (
                            <span> ({roomProblems.length}) </span>
                          )}
                        </span>
                    </div>
                    {isProblemListVisible && (
                        <div
                          style={{
                            position: 'absolute',
                            top: `${y + 20}px`,
                            left: `${x + 20}px`,
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            border: '1px solid #ddd',
                            padding: '10px',
                            borderRadius: '4px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                            cursor: 'pointer',
                          }}
                          onClick={() => toggleRoomVisibility(room.id)}
                        >
                          <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                            {roomProblems.length > 0 && roomProblems.map((problem, index) => (
                              <li key={index} style={{ fontSize: `${fontSize}px` }}>{problem.kind}</li>
                            ))}
                            {roomProblems.length === 0 && (
                                <li style={{ fontSize: `${fontSize}px` }}>No problem</li>
                            )}
                          </ul>
                        </div>
                    )}
                  </React.Fragment>
                  );
                })}
                {/* Pinezka wyświetlana na obrazie */}
                {pinCoordinates.x !== null && pinCoordinates.y !== null && (
                  <div
                    style={{
                      position: 'absolute',
                      top: `${pinCoordinates.y}px`,
                      left: `${pinCoordinates.x}px`,
                      width: '24px',
                      height: '24px',
                      backgroundColor: 'red',
                      borderRadius: '50%',
                      boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                      transform: 'translate(-50%, -50%)', // Wyśrodkowanie pinezki w punkcie kliknięcia
                      cursor: 'pointer',
                    }}
                    title={`X: ${pinCoordinates.x.toFixed(0)}, Y: ${pinCoordinates.y.toFixed(0)}`}
                  />
                )}

              </div>
            </>
          )}
        </div>
      ) : (
        <p>Ładowanie danych...</p>
      )}
    </div>
  );
}

export default TFloorsView;
